// extracted by mini-css-extract-plugin
export default {"iconEdit":"ConnectionSideSelf-module-f51873cfa0f63bbb5205"};